export const cTipoRegistroCuentaCorriente = {
    VENTA: 1,
    PAGO: 2,
    AJUSTEDEBITO: 3,
    AJUSTECREDITO: 4
}
